import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const manager = localStorage.getItem("isLoggedIn");
  const profile = localStorage.getItem("profileLoggedIn");

  // If visiting manager page
  if (location.pathname === "/manager" && !manager) {
    return <Navigate to="/login" />;
  }

  // If visiting profile page
  if (location.pathname === "/profile" && !profile) {
    return <Navigate to="/register" />;
  }

  return children;
};

export default ProtectedRoute;
